import Profile from "../components/Layout/Profile/Profile";

const UserProfilePage = () => {
  return <Profile />;
};

export default UserProfilePage;
